import { defineComponent as _defineComponent } from 'vue'
import { reactive, computed, ref } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { numeric, required } from "@vuelidate/validators";
  import store from "@/store";
  import router from "@/router";
  import { CreateLotMapInterface } from "@/types/CreateLotMapInterface";
  import { useToast } from "vue-toastification";
  import {
    applyDetectedLotMapSvgData,
    getHouseMarkerFromForm,
    isSvgFile,
  } from "@/helpers/lot/detectLotMapSvgData";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLotMapCreate',
  setup(__props, { expose: __expose }) {
  __expose();

  const userId = router.currentRoute.value.params.userId as string;
  const estateId = router.currentRoute.value.params.estateId as string;
  const stageId = router.currentRoute.value.params.stageId as string;
  const lotId = router.currentRoute.value.params.lotId as string;
  const form = reactive({
    width: 0,
    height: 0,
    x: 0,
    y: 0,
    path: "",
    statusPath: "",
    svgFileName: "",
    houseX: "" as string | number,
    houseY: "" as string | number,
    houseWidth: "" as string | number,
    houseHeight: "" as string | number,
  });
  const rules = computed(() => {
    return {
      width: { required, numeric, $autoDirty: true },
      height: { required, numeric, $autoDirty: true },
      x: { required, numeric, $autoDirty: true },
      y: { required, numeric, $autoDirty: true },
      path: { required, $autoDirty: true },
      statusPath: { required, $autoDirty: true },
    };
  });
  const v$ = useVuelidate(rules, form);
  const loading = ref(false);
  const toast = useToast();

  async function createMap() {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) return;

    loading.value = true;
    const data: CreateLotMapInterface = {
      landownerId: userId,
      stageId,
      lotId,
      path: form.path,
      statusPath: form.statusPath,
      houseMarker: getHouseMarkerFromForm(form),
      binding: {
        x: form.x,
        y: form.y,
      },
      size: {
        width: form.width,
        height: form.height,
      },
    };

    store
      .dispatch("lot/createLotMap", data)
      .then(() => {
        router.push({
          name: "AdminLotMap",
          params: { userId, estateId, stageId, lotId },
        });
      })
      .catch(() => {
        loading.value = false;
        toast.error("Something went wrong");
      });
  }

  async function onSvgFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) return;

    if (!isSvgFile(file)) {
      toast.error("Please choose an SVG file");
      input.value = "";
      form.svgFileName = "";
      return;
    }

    try {
      const svgSource = await file.text();

      if (detectFromSvg(svgSource)) {
        form.svgFileName = file.name;
      } else {
        input.value = "";
        form.svgFileName = "";
      }
    } catch {
      toast.error("Could not read SVG file");
      input.value = "";
      form.svgFileName = "";
    }
  }

  function detectFromSvg(svgSource: string): boolean {
    try {
      applyDetectedLotMapSvgData(form, svgSource);

      toast.success("Lot map data detected from SVG");
      return true;
    } catch (error) {
      toast.error(
        error instanceof Error ? error.message : "Could not detect SVG data"
      );
      return false;
    }
  }

const __returned__ = { userId, estateId, stageId, lotId, form, rules, v$, loading, toast, createMap, onSvgFileChange, detectFromSvg, reactive, computed, ref, get useVuelidate() { return useVuelidate }, get numeric() { return numeric }, get required() { return required }, get store() { return store }, get router() { return router }, get CreateLotMapInterface() { return CreateLotMapInterface }, get useToast() { return useToast }, get applyDetectedLotMapSvgData() { return applyDetectedLotMapSvgData }, get getHouseMarkerFromForm() { return getHouseMarkerFromForm }, get isSvgFile() { return isSvgFile } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})